import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { useNavigate, useParams } from 'react-router-dom';

import withErrorBoundary from 'src/components/errorBoundary/withErrorBoundary';

import DealHeader from './components/dealHeader';
import DealTimeline from './components/dealTimeline';
import DealActivity from '../components/dealActivity';
import DealContacts from './components/dealContacts';
import ContentShared from './components/contentShared';

import styles from './styles.module.scss';
import Actions from 'src/components/actionbar';
import { useDealDetail, useSyncDeal } from 'src/query/dealInsights/dealInsights';
import { toast } from "react-toastify";
import Toast from "src/components/toast";
import { useQueryClient } from '@tanstack/react-query';
import { DEAL_DETAILS, DEAL_INSIGHTS, DEAL_INSIGHTS_ACTIVITIES, INVALIDATE } from 'src/query/queryKeys';

export const DealDetailsView = () => {

  const navigate = useNavigate();
  const { id } = useParams(); // get the deal id
  const queryClient = useQueryClient();

  // query's
  const { data: dealDetails, isLoading: isLoadingDealDetails, refetch: refetchDealDetails, isRefetching: isDealDetailsRefetching } = useDealDetail(id); // deal details
  const { mutate: syncDeal, isSuccess: isSyncSuccess, isPending: isSyncPending, } = useSyncDeal(); // sync 

  // Methods
  useEffect(() => {
    if (isSyncSuccess) {
      toast(
        <Toast.Sucess
          message="Sucessfully Synced"
        />, {
        autoClose: 3000,
      })
    }
  }, [isSyncSuccess]);

  const handleBack = () => { // go back
    navigate('/deal-insights');
    queryClient.removeQueries({ // clear the cache
      queryKey: [DEAL_INSIGHTS]
    });
    queryClient.removeQueries({ queryKey: [INVALIDATE, DEAL_DETAILS, DEAL_INSIGHTS_ACTIVITIES] });
  };

  return (
    <div className={cx(styles.detailsContainer)}>
      <div className={styles.topBar}>
        <button className={styles.backButton} onClick={handleBack}>
          <i className="paperflite-left-arrow" /> back to  <span className={styles.highlight}> &quot;deals&quot; </span>
        </button>
        <div className={styles.syncStatus}>
          <p className={styles.content}>{isSyncPending ? 'Syncing' : 'Last synced today'}</p>
          <Actions.IconButton
            icon="paperflite-reverse-curved"
            onClick={() => { syncDeal(dealDetails?.externalId ?? '') }}
            className={styles.icon}
            disabled={isSyncPending}
          />
        </div>
      </div>
      <div className={styles.mainContent}>
        <div className={styles.leftPane}></div>
        <div className={styles.contentWrapper}>
          <DealHeader deal={dealDetails} isLoading={isLoadingDealDetails || isDealDetailsRefetching} />
          <DealTimeline dealId={dealDetails?.externalId ?? ''} />
          <DealActivity isDetailedView={true} dealId={dealDetails?.externalId ?? ''} title={'Deal Activity'} />
          <DealContacts contacts={dealDetails?.contacts || []} />
          {/* <ContentShared items={mockData.contentShared as any} /> */}
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(DealDetailsView);
